import * as React from "react";
import { useState, useEffect } from "react";
import PofilePicture from "../../resources/icons/profile-circle-disabled.svg";
import DownArrow from "../../resources/icons/chevron-down.svg";
import Cart from "../../resources/icons/Add-To-Cart-256 1.svg";
import Stacks from "../../resources/icons/Coins-icon-1.svg";
import { useTranslation } from "react-i18next";

function SettingTemplate() {
  const { t } = useTranslation();

  const [isProfileOpen, setIsProfileOpen] = useState(true);
  const [isBillingOpen, setIsBillingOpen] = useState(false);

  const toggleProfile = () => setIsProfileOpen(!isProfileOpen);
  const toggleBilling = () => setIsBillingOpen(!isBillingOpen);

  return (
    <div className="pt-32 bg-cfSecondary w-full min-h-screen h-full px-10 pb-6">
      {/* Profile Section */}
      <div className="mb-4 border rounded-xl">
        <div
          id="settings-toggle-profile-section"
          className={`flex ${
            isProfileOpen ? "justify-end pt-4 px-4" : "justify-between p-4"
          } items-center cursor-pointer`}
          onClick={toggleProfile}
        >
          {!isProfileOpen && (
            <h2 className="font-semibold text-3xl text-black">
              {t("settings:upload_profile_photo")}
            </h2>
          )}
          <img
            src={DownArrow}
            className={`w-8 h-8 transform transition-transform duration-300 ${
              isProfileOpen ? "rotate-180" : ""
            }`}
            alt=""
          />
        </div>
        {isProfileOpen && (
          <div className="px-4 pb-4">
            <div className="flex items-center mb-4 justify-between">
              <div className="flex items-center gap-8 justify-center">
                {/* Profile Icon */}
                <img src={PofilePicture} className="w-24 h-24" alt="" />
                <h1 className="text-3xl font-semibold text-black">
                  {t("settings:upload_profile_photo")}
                </h1>
              </div>
              <button
                id="settings-upload-photo-button"
                className="px-4 py-2 rounded-full text-[#0E519A] text-xl  font-semibold border-2 border-[#0E519A]"
              >
                {t("settings:upload_photo")}
              </button>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <span className="max-w-lg">
                <label
                  htmlFor="settings-name-input"
                  className="text-xl font-semibold text-black"
                >
                  {t("settings:name")}
                </label>
                <input
                  id="settings-name-input"
                  type="text"
                  placeholder={t("settings:name")}
                  className="border rounded-lg p-2 w-full"
                  value="Himaja Dhanyamraju"
                  name="name"
                />
              </span>
              <span className="max-w-lg">
                <label
                  htmlFor="settings-gender-input"
                  className="text-xl font-semibold text-black"
                >
                  {t("settings:gender")}
                </label>
                <input
                  id="settings-gender-input"
                  type="text"
                  placeholder={t("settings:gender")}
                  className="border rounded-lg p-2 w-full text-lg placeholder:text-lg"
                  value="Female"
                  name="gender"
                />
              </span>
              <span className="max-w-lg">
                <label
                  htmlFor="settings-email-input"
                  className="text-xl font-semibold text-black"
                >
                  {t("settings:email")}
                </label>
                <input
                  id="settings-email-input"
                  type="text"
                  placeholder={t("settings:email_address")}
                  className="border rounded-lg p-2 w-full"
                  value="himaja.d@gmail.com"
                  name="email"
                />
              </span>
              <span className="max-w-lg">
                <label
                  htmlFor="settings-dob-input"
                  className="text-xl font-semibold text-black"
                >
                  {t("settings:date_of_birth")}
                </label>
                <input
                  id="settings-dob-input"
                  type="text"
                  placeholder={t("settings:date_of_birth")}
                  className="border rounded-lg p-2 w-full"
                  value="27/06/1996"
                  name="dob"
                />
              </span>
              <span className="max-w-lg">
                <label
                  htmlFor="settings-mobile-input"
                  className="text-xl font-semibold text-black"
                >
                  {t("settings:mobile_no")}
                </label>
                <input
                  id="settings-mobile-input"
                  type="text"
                  placeholder={t("settings:mobile")}
                  className="border rounded-lg p-2 w-full"
                  value="+91 9999999999"
                  name="mobile"
                />
              </span>
              <button
                id="settings-save-profile-button"
                className="w-fit h-fit px-4 py-2 rounded-full text-[#0E519A] text-xl  font-semibold border-2 border-[#0E519A]  place-self-end "
              >
                {t("settings:save")}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Billing Section */}
      <div className="mb-4 border rounded-xl">
        <div
          id="settings-toggle-billing-section"
          className="flex justify-between items-center p-4 cursor-pointer"
          onClick={toggleBilling}
        >
          <h2 className="text-3xl font-semibold text-black">
            {t("settings:billing_and_plans")}
          </h2>
          <img
            src={DownArrow}
            className={`w-8 h-8 transform transition-transform duration-300 ${
              isBillingOpen ? "rotate-180" : ""
            }`}
            alt=""
          />
        </div>
        {isBillingOpen && (
          <div className="p-4">
            <h1 className="text-2xl font-semibold text-black mb-6">
              {t("settings:credits")}
            </h1>
            <p className="text-xl text-black">
              {t("settings:you_have_50_credits")}
            </p>
            <h3 className="font-semibold text-2xl text-black my-4">
              {t("settings:explore_subscription_packs")}
            </h3>
            <div className="flex items-center gap-16 mt-2">
              {/* Pack 1 */}
              <div className="px-4 py-10 text-center flex flex-col items-center justify-between h-80 w-[19rem] border-[1.5px] border-black rounded-2xl">
                <p className="font-bold flex gap-4 items-baseline text-4xl">
                  <img src={Stacks} alt="" />
                  50
                </p>
                <p className="text-black text-xl">
                  {t("settings:with_pack_view")} 50 {t("settings:certificates")}
                </p>
                <button
                  id="settings-buy-pack-50-button"
                  className="mt-2 bg-cfPrimary text-white font-semibold px-4 py-2 rounded-lg flex gap-4 items-center"
                >
                  <img src={Cart} alt="" />
                  {t("settings:buy_for")} ₹500
                </button>
              </div>
              {/* Pack 2 */}
              <div className="px-4 py-10 text-center flex flex-col items-center justify-between h-80 w-[19rem] border-[1.5px] border-black rounded-2xl">
                <p className="font-bold flex gap-4 items-baseline text-4xl">
                  <img src={Stacks} alt="" />
                  170
                </p>
                <p className="text-black text-xl">
                  {t("settings:with_pack_view")} 170{" "}
                  {t("settings:certificates")}
                </p>
                <button
                  id="settings-buy-pack-170-button"
                  className="mt-2 bg-cfPrimary text-white font-semibold px-4 py-2 rounded-lg flex gap-4 items-center"
                >
                  <img src={Cart} alt="" />
                  {t("settings:buy_for")} ₹1500
                </button>
              </div>
              {/* Pack 3 */}
              <div className="px-4 py-10 text-center flex flex-col items-center justify-between h-80 w-[19rem] border-[1.5px] border-black rounded-2xl">
                <p className="font-bold flex gap-4 items-center text-4xl">
                  <img src={Stacks} alt="" />
                  420
                </p>
                <p className="text-black text-xl">
                  {t("settings:with_pack_view")} 420{" "}
                  {t("settings:certificates")}
                </p>
                <button
                  id="settings-buy-pack-420-button"
                  className="mt-2 bg-cfPrimary text-white font-semibold px-4 py-2 rounded-lg flex gap-4 items-center"
                >
                  <img src={Cart} alt="" />
                  {t("settings:buy_for")} ₹3500
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SettingTemplate;
